import { TAbUseExperiment } from '../../types/experiments';

const defaultState: TAbUseExperiment[] = [];

export function experimentsReducer(state: TAbUseExperiment[] = defaultState) {
  return state;
}
